import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import { notify } from '../../util/notifications';
import { getAccessLevelsByModule } from '../../util/customMethods';
import {
    getEmployeeCommissionTypes,
    addEmployeeCommissionType,
    getCommissionTypes,
    onCommissionTypeNameFieldChange
} from '../../actions/adminAction/commissionActions';

const pageTitle = "Employee Commission Types";

class CommissionPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAddModal: false,
            newTypeName: ''
        };
    }

    componentDidMount() {
        document.title = pageTitle;
        this.loadCommissionTypes();
    }

    loadCommissionTypes = () => {
        const { dispatch } = this.props;
        dispatch(getEmployeeCommissionTypes());
    }

    checkViewAccess = (accessLevel = {}) => {
        if (accessLevel.basicAccess.view !== true) {
            this.props.history.push('/admin/notfound');
        }
    }

    handleAddClick = () => {
        this.setState({ 
            showAddModal: true, 
            newTypeName: '' 
        });
    }

    handleCloseModal = () => {
        this.setState({ 
            showAddModal: false, 
            newTypeName: '' 
        });
    }

    handleSaveType = async () => {
        const { dispatch } = this.props;
        const { newTypeName } = this.state;
        
        if (!newTypeName.trim()) {
            notify.createNotification('error', 'Please enter a commission type name', this.props.refNotify);
            return;
        }
        
        const res = await dispatch(addEmployeeCommissionType(newTypeName));
        if (res.statusCode === 200) {
            notify.createNotification('success', res.statusMsg, this.props.refNotify);
            this.handleCloseModal();
            this.loadCommissionTypes();
            dispatch(getCommissionTypes());
        } else {
            notify.createNotification('error', res.statusMsg || 'Failed to add commission type', this.props.refNotify);
        }
    }

    handleConfigureClick = (type) => {
        // Navigate to configuration page with simplified parameters
        this.props.history.push(`/admin/commissionDetails?typeId=${type.commissionTypeId}&typeName=${type.commissionType}`);
    }

    render() {
        const accessLevelObj = getAccessLevelsByModule('Commission');
        this.checkViewAccess(accessLevelObj);
        
        const { employeeCommissionTypes = [] } = this.props.commission;
        const canAdd = (accessLevelObj.basicAccess.add || false) === true;
        const canEdit = (accessLevelObj.basicAccess.edit || false) === true;

        return (
            <Fragment>
                <div className="page-header">
                    <div className="row mb-10">
                        <div className="col-md-6 col-sm-12">
                            <div className="title">
                                <h4><i className="fa fa-money"></i> Employee Commission Types</h4>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pd-30 bg-white border-radius-4 box-shadow container-box">
                    <div className="row">
                        <div className="col-md-12">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th style={{ position: 'relative' }}>
                                            Commission Type Name
                                            {canAdd && (
                                                <button 
                                                    className="btn btn-sm btn-primary"
                                                    style={{ 
                                                        position: 'absolute', 
                                                        right: '10px', 
                                                        top: '50%', 
                                                        transform: 'translateY(-50%)' 
                                                    }}
                                                    onClick={this.handleAddClick}
                                                    title="Add Commission Type"
                                                >
                                                    <i className="fa fa-plus"></i>
                                                </button>
                                            )}
                                        </th>
                                        <th width="200">Status</th>
                                        <th width="150">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {employeeCommissionTypes.length === 0 ? (
                                        <tr>
                                            <td colSpan="3" className="text-center">
                                                <div className="py-3">
                                                    <i className="fa fa-info-circle"></i> No commission types created yet.
                                                    {canAdd && (
                                                        <span> Click the <i className="fa fa-plus"></i> button to add one.</span>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ) : (
                                        employeeCommissionTypes.map((type, index) => (
                                            <tr key={index}>
                                                <td>{type.commissionType}</td>
                                                <td>
                                                    {type.isConfigured === 1 ? (
                                                        <span className="badge badge-success">Configured</span>
                                                    ) : (
                                                        <span className="badge badge-warning">Not Configured</span>
                                                    )}
                                                </td>
                                                <td>
                                                    <button 
                                                        className="btn btn-sm btn-info"
                                                        onClick={() => this.handleConfigureClick(type)}
                                                        disabled={!canEdit}
                                                    >
                                                        <i className="fa fa-cog"></i> Configure
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Simple Add Modal */}
                <Modal show={this.state.showAddModal} onHide={this.handleCloseModal}>
                    <Modal.Header>
                        <Modal.Title>Add Commission Type</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group">
                            <label>Commission Type Name:</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.newTypeName}
                                onChange={(e) => this.setState({ newTypeName: e.target.value })}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        this.handleSaveType();
                                    }
                                }}
                                placeholder="Enter commission type name"
                                autoFocus
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button 
                            className="btn btn-secondary" 
                            onClick={this.handleCloseModal}
                        >
                            Cancel
                        </button>
                        <button 
                            className="btn btn-primary" 
                            onClick={this.handleSaveType}
                        >
                            OK
                        </button>
                    </Modal.Footer>
                </Modal>
            </Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        refNotify: state.refNotify,
        commission: state.commission
    };
};

export default withRouter(connect(mapStateToProps)(CommissionPage));